import {fadeIn} from '@pernod-ricard-global-cms/jsanimations';
import {loadCss} from "v-js-utils";

export default function instagramfeedJs ( options = {} ) {
	try {
		const { block } = options;
		loadCss( block.dataset.assetkey, options ).then( () => {
			// Add your Javascript code here...
			fadeIn( block );
		});
	} catch ( error ) {
		console.error( error );
	}
}